import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { OrdersComponent } from './orders/orders.component';
import { ProfilComponent } from './profil/profil.component';
import { ContactComponent } from './contact/contact.component';
import { PipesModule } from '@app/pipes/pipes.module';
import { RestaurantComponent } from './restaurant/restaurant.component';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './views.routing';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/modules/shared/shared.module';
// import { TicketComponent } from '@app/components/ticket/ticket.component';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { CgvComponent } from './cgv/cgv.component';
import { OrderPayInModule } from '@app/components/order-pay/order-pay.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        routing,
        SharedModule,
        CommonComponentsModule,
        PipesModule,
        AbsolutePathModule,
        OrderPayInModule
    ],
    declarations: [
        RestaurantComponent,
        ContactComponent,
        ProfilComponent,
        OrdersComponent,
        CgvComponent,
        LegalNoticeComponent
    ],
    exports: [
    ]
})

export class ViewsModule {

}
